module.exports = __webpack_public_path__ + "static/img/icon4.34816a6f.png";